/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

const createAboutUsSectionStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      minHeight: '100vh',
      backgroundColor: theme.palette.primary.main,
      paddingTop: 'calc(100% * (150 / 1440))',
      paddingRight: 'calc(100% * (197 / 1440))',
      paddingBottom: 'calc(100% * (150 / 1440))',
      paddingLeft: 'calc(100% * (150 / 1440))',
    },
    plxBlock: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
    },
    container: {
      maxWidth: '1140px',
      marginLeft: 'auto',
      marginRight: 'auto',
    },
    text: {
      color: '#ffffff',
      maxWidth: '670px',
    },
    textTransparent: {
      opacity: '.4',
      marginBottom: '96px',
    },
    textHighlighted: {
      '& > strong': {
        color: theme.palette.secondary.main,
      },
    },
    gridFlex: {
      display: 'flex',
      alignItems: 'flex-end',
      justifyContent: 'flex-end',
    },
  }),
);

export { createAboutUsSectionStyles };
